<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kgDjEF/images/cover.jpg?1703000751117" alt="This image is the cover for the book Hidden History of Ravenswood and Lake View, Hidden History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hidden History of Ravenswood and Lake View, Hidden History
      </h1>
      <p class="bookDescription body article font2">
        <p>It's easy to get caught up in the hidden history of Ravenswood and Lake View, like the Harm's Park picnic that lasted fifty-four years or the political gimmickry of the "Cowboy Mayor" of Chicago. Who can resist a double take over folk like the "Father of Ravenswood," who kept Chicago from falling to the Confederacy, or the "North Side's Benedict Arnold," who was sent to the electric chair during World War II? If you want to visit the days when the Cubs were the Spuds or debate whether Ravenswood is an actual neighborhood or just a state of mind, do it with longtime North Side journalist Patrick Butler in this curio shop of forgotten people and places.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick Butler
      </h2>
      
      <p class="authorDescription body article">Patrick Butler is a lifelong Chicagoan who has covered the North Side for the past 35 years and currently writes for Inside Publications' Booster and News-Star.  He served more than a dozen years as president of the Ravenswood/Lake View Historical Association and for several years anchored a a cable TV news/feature magazine, "North Side Neighbors."</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?741b6f46